/*
 *@providesModule FlagResource
 *
 */

import AssetHelper from 'AssetHelper'
let instance = null

class FlagResource {
    static getInstance() {
        if (!instance) {
            instance = new FlagResource()
        }
        return instance
    }

    constructor() {

        this.flags = {
            'ad': 'flagImages/ad.png',
            'ae': 'flagImages/ae.png',
            'af': 'flagImages/af.png',
            'ag': 'flagImages/ag.png',
            'ai': 'flagImages/ai.png',
            'al': 'flagImages/al.png',
            'am': 'flagImages/am.png',
            'ao': 'flagImages/ao.png',
            'ar': 'flagImages/ar.png',
            'as': 'flagImages/as.png',
            'at': 'flagImages/at.png',
            'au': 'flagImages/au.png',
            'aw': 'flagImages/aw.png',
            'ax': 'flagImages/ax.png',
            'az': 'flagImages/az.png',
            'ba': 'flagImages/ba.png',
            'bb': 'flagImages/bb.png',
            'bd': 'flagImages/bd.png',
            'be': 'flagImages/be.png',
            'bf': 'flagImages/bf.png',
            'bg': 'flagImages/bg.png',
            'bh': 'flagImages/bh.png',
            'bi': 'flagImages/bi.png',
            'bj': 'flagImages/bj.png',
            'bl': 'flagImages/bl.png',
            'bm': 'flagImages/bm.png',
            'bn': 'flagImages/bn.png',
            'bo': 'flagImages/bo.png',
            'bq': 'flagImages/bq.png',
            'br': 'flagImages/br.png',
            'bs': 'flagImages/bs.png',
            'bt': 'flagImages/bt.png',
            'bw': 'flagImages/bw.png',
            'by': 'flagImages/by.png',
            'bz': 'flagImages/bz.png',
            'ca': 'flagImages/ca.png',
            'cc': 'flagImages/cc.png',
            'cd': 'flagImages/cd.png',
            'cf': 'flagImages/cf.png',
            'cg': 'flagImages/cg.png',
            'ch': 'flagImages/ch.png',
            'ci': 'flagImages/ci.png',
            'ck': 'flagImages/ck.png',
            'cl': 'flagImages/cl.png',
            'cm': 'flagImages/cm.png',
            'cn': 'flagImages/cn.png',
            'co': 'flagImages/co.png',
            'cr': 'flagImages/cr.png',
            'cu': 'flagImages/cu.png',
            'cv': 'flagImages/cv.png',
            'cw': 'flagImages/cw.png',
            'cx': 'flagImages/cx.png',
            'cy': 'flagImages/cy.png',
            'cz': 'flagImages/cz.png',
            'de': 'flagImages/de.png',
            'dj': 'flagImages/dj.png',
            'dk': 'flagImages/dk.png',
            'dm': 'flagImages/dm.png',
            'do': 'flagImages/do.png',
            'dz': 'flagImages/dz.png',
            'ec': 'flagImages/ec.png',
            'ee': 'flagImages/ee.png',
            'eg': 'flagImages/eg.png',
            'eh': 'flagImages/eh.png',
            'er': 'flagImages/er.png',
            'es': 'flagImages/es.png',
            'et': 'flagImages/et.png',
            'fi': 'flagImages/fi.png',
            'fj': 'flagImages/fj.png',
            'fk': 'flagImages/fk.png',
            'fm': 'flagImages/fm.png',
            'fo': 'flagImages/fo.png',
            'fr': 'flagImages/fr.png',
            'ga': 'flagImages/ga.png',
            'gb': 'flagImages/gb.png',
            'gd': 'flagImages/gd.png',
            'ge': 'flagImages/ge.png',
            'gf': 'flagImages/gf.png',
            'gg': 'flagImages/gg.png',
            'gh': 'flagImages/gh.png',
            'gi': 'flagImages/gi.png',
            'gm': 'flagImages/gm.png',
            'gn': 'flagImages/gn.png',
            'gp': 'flagImages/gp.png',
            'gq': 'flagImages/gq.png',
            'gr': 'flagImages/gr.png',
            'gt': 'flagImages/gt.png',
            'gu': 'flagImages/gu.png',
            'gw': 'flagImages/gw.png',
            'gy': 'flagImages/gy.png',
            'hk': 'flagImages/hk.png',
            'hn': 'flagImages/hn.png',
            'hr': 'flagImages/hr.png',
            'ht': 'flagImages/ht.png',
            'hu': 'flagImages/hu.png',
            'id': 'flagImages/id.png',
            'ie': 'flagImages/ie.png',
            'il': 'flagImages/il.png',
            'im': 'flagImages/im.png',
            'in': 'flagImages/in.png',
            'io': 'flagImages/io.png',
            'iq': 'flagImages/iq.png',
            'ir': 'flagImages/ir.png',
            'is': 'flagImages/is.png',
            'it': 'flagImages/it.png',
            'je': 'flagImages/je.png',
            'jm': 'flagImages/jm.png',
            'jo': 'flagImages/jo.png',
            'jp': 'flagImages/jp.png',
            'ke': 'flagImages/ke.png',
            'kg': 'flagImages/kg.png',
            'kh': 'flagImages/kh.png',
            'ki': 'flagImages/ki.png',
            'km': 'flagImages/km.png',
            'kn': 'flagImages/kn.png',
            'kp': 'flagImages/kp.png',
            'kr': 'flagImages/kr.png',
            'ks': 'flagImages/ks.png',
            'kw': 'flagImages/kw.png',
            'ky': 'flagImages/ky.png',
            'kz': 'flagImages/kz.png',
            'la': 'flagImages/la.png',
            'lb': 'flagImages/lb.png',
            'lc': 'flagImages/lc.png',
            'li': 'flagImages/li.png',
            'lk': 'flagImages/lk.png',
            'lr': 'flagImages/lr.png',
            'ls': 'flagImages/ls.png',
            'lt': 'flagImages/lt.png',
            'lu': 'flagImages/lu.png',
            'lv': 'flagImages/lv.png',
            'ly': 'flagImages/ly.png',
            'ma': 'flagImages/ma.png',
            'mc': 'flagImages/mc.png',
            'md': 'flagImages/md.png',
            'me': 'flagImages/me.png',
            'mf': 'flagImages/mf.png',
            'mg': 'flagImages/mg.png',
            'mh': 'flagImages/mh.png',
            'mk': 'flagImages/mk.png',
            'ml': 'flagImages/ml.png',
            'mm': 'flagImages/mm.png',
            'mn': 'flagImages/mn.png',
            'mo': 'flagImages/mo.png',
            'mp': 'flagImages/mp.png',
            'mq': 'flagImages/mq.png',
            'mr': 'flagImages/mr.png',
            'ms': 'flagImages/ms.png',
            'mt': 'flagImages/mt.png',
            'mu': 'flagImages/mu.png',
            'mv': 'flagImages/mv.png',
            'mw': 'flagImages/mw.png',
            'mx': 'flagImages/mx.png',
            'my': 'flagImages/my.png',
            'mz': 'flagImages/mz.png',
            'na': 'flagImages/na.png',
            'nc': 'flagImages/nc.png',
            'ne': 'flagImages/ne.png',
            'nf': 'flagImages/nf.png',
            'ng': 'flagImages/ng.png',
            'ni': 'flagImages/ni.png',
            'nl': 'flagImages/nl.png',
            'no': 'flagImages/no.png',
            'np': 'flagImages/np.png',
            'nr': 'flagImages/nr.png',
            'nu': 'flagImages/nu.png',
            'nz': 'flagImages/nz.png',
            'om': 'flagImages/om.png',
            'pa': 'flagImages/pa.png',
            'pe': 'flagImages/pe.png',
            'pf': 'flagImages/pf.png',
            'pg': 'flagImages/pg.png',
            'ph': 'flagImages/ph.png',
            'pk': 'flagImages/pk.png',
            'pl': 'flagImages/pl.png',
            'pm': 'flagImages/pm.png',
            'pr': 'flagImages/pr.png',
            'ps': 'flagImages/ps.png',
            'pt': 'flagImages/pt.png',
            'pw': 'flagImages/pw.png',
            'py': 'flagImages/py.png',
            'qa': 'flagImages/qa.png',
            're': 'flagImages/re.png',
            'ro': 'flagImages/ro.png',
            'rs': 'flagImages/rs.png',
            'ru': 'flagImages/ru.png',
            'rw': 'flagImages/rw.png',
            'sa': 'flagImages/sa.png',
            'sb': 'flagImages/sb.png',
            'sc': 'flagImages/sc.png',
            'sd': 'flagImages/sd.png',
            'se': 'flagImages/se.png',
            'sg': 'flagImages/sg.png',
            'sh': 'flagImages/sh.png',
            'si': 'flagImages/si.png',
            'sj': 'flagImages/sj.png',
            'sk': 'flagImages/sk.png',
            'sl': 'flagImages/sl.png',
            'sm': 'flagImages/sm.png',
            'sn': 'flagImages/sn.png',
            'so': 'flagImages/so.png',
            'sr': 'flagImages/sr.png',
            'ss': 'flagImages/ss.png',
            'st': 'flagImages/st.png',
            'sv': 'flagImages/sv.png',
            'sx': 'flagImages/sx.png',
            'sy': 'flagImages/sy.png',
            'sz': 'flagImages/sz.png',
            'tc': 'flagImages/tc.png',
            'td': 'flagImages/td.png',
            'tg': 'flagImages/tg.png',
            'th': 'flagImages/th.png',
            'tj': 'flagImages/tj.png',
            'tk': 'flagImages/tk.png',
            'tl': 'flagImages/tl.png',
            'tm': 'flagImages/tm.png',
            'tn': 'flagImages/tn.png',
            'to': 'flagImages/to.png',
            'tr': 'flagImages/tr.png',
            'tt': 'flagImages/tt.png',
            'tv': 'flagImages/tv.png',
            'tw': 'flagImages/tw.png',
            'tz': 'flagImages/tz.png',
            'ua': 'flagImages/ua.png',
            'ug': 'flagImages/ug.png',
            'us': 'flagImages/us.png',
            'uy': 'flagImages/uy.png',
            'uz': 'flagImages/uz.png',
            'va': 'flagImages/va.png',
            'vc': 'flagImages/vc.png',
            've': 'flagImages/ve.png',
            'vg': 'flagImages/vg.png',
            'vi': 'flagImages/vi.png',
            'vn': 'flagImages/vn.png',
            'vu': 'flagImages/vu.png',
            'wf': 'flagImages/wf.png',
            'ws': 'flagImages/ws.png',
            'ye': 'flagImages/ye.png',
            'yt': 'flagImages/yt.png',
            'za': 'flagImages/za.png',
            'zm': 'flagImages/zm.png',
            'zw': 'flagImages/zw.png',
        }
    }

    get(name) {
        return {uri: this.flags[name]}
    }
}

export default FlagResource.getInstance()
